<template>
  <button
    type="button"
    class="button-colors flex h-6 w-6 items-center justify-center rounded-full"
  >
    <!-- prettier-ignore -->
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" fill="none">
      <path
        fill="currentColor"
        d="M2.24.385A.86.86 0 0 0 1.052.39c-.324.33-.318.884-.013 1.189l3.762 3.762-3.756 3.756a.854.854 0 0 0 .007 1.188c.33.324.87.324 1.188.007l3.756-3.756 3.762 3.756a.848.848 0 0 0 1.189-.007.854.854 0 0 0 .006-1.188L7.197 5.342l3.756-3.762A.854.854 0 0 0 10.947.39c-.324-.324-.883-.318-1.188-.006L5.995 4.14 2.24.385Z"
      />
    </svg>
  </button>
</template>

<style scoped>
  .button-colors {
    background-color: var(
      --header-close-button-background-color,
      rgb(var(--situational-lightgrey))
    );
    color: var(
      --header-close-button-cross-color,
      rgb(var(--text-neutral-quaternary))
    );
  }
</style>
